<template>
    <BreadCrumb PageTitle="Générer une redevance Tempon" />
    <GenererRedevanceTempon />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import GenererRedevanceTempon from "../../components/Redevance/GenererRedevanceTempon.vue";
  
    export default defineComponent({
      name: "GenererRedevanceTemponPage",
      components: {
        BreadCrumb,
        GenererRedevanceTempon,
      },
    });
  </script>